import { createAppReducer, apiReducerSwitch } from 'lib/redux/reducerUtils'
import { API_CALL_FAILURE, API_CALL_REQUEST, API_CALL_SUCCESS, CLEAR_LOYALTY_ENROLMENT } from 'actions/actionConstants'
import {
  USER_LOGOUT,
  ENROL_LOYALTY_ACCOUNT,
  FETCH_LOYALTY_ACCOUNT,
  FETCH_LOYALTY_ACCOUNT_ELIGIBILITY,
  FETCH_LOYALTY_POINTS_EARN_CALCULATION,
  SUBMIT_LOYALTY_POINTS_BURN_CALCULATION,
  FETCH_LOYALTY_CONFIG,
  FETCH_LOYALTY_ACCOUNT_ACTIVITY,
  FETCH_LOYALTY_ACCOUNT_PENDING_POINTS,
  FETCH_LATEST_LOYALTY_ACCOUNT_DETAILS,
} from 'actions/apiActionConstants'
import moment from 'moment'

export const INITIAL_LOYALTY_STATE: App.LoyaltyState = {
  enrolment: undefined,
  account: { initial: true },
  eligibilityTier: { initial: true },
  pointsEarnCalculations: {},
  pointsBurnCalculations: {},
  config: undefined,
  configError: undefined,
  fetchingConfig: false,
  accountActivity: { initial: true },
  accountPendingPoints: { initial: true },
}

const apiCalls = apiReducerSwitch<App.LoyaltyState>({
  [ENROL_LOYALTY_ACCOUNT]: {
    request: () => ({
      account: {
        fetching: true,
        error: undefined,
      },
    }),
    success: (_state, action) => ({
      account: {
        data: action.data,
        fetching: false,
        error: undefined,
      },
      enrolment: action.enrolment,
    }),
    failure: (_state, action) => ({
      account: {
        fetching: false,
        error: action.error,
      },
    }),
  },
  [FETCH_LOYALTY_ACCOUNT_ACTIVITY]: {
    request: () => ({
      accountActivity: {
        fetching: true,
        error: undefined,
      },
    }),
    success: (_state, action) => ({
      accountActivity: {
        data: action.data,
        fetching: false,
        error: undefined,
      },
    }),
    failure: (_state, action) => ({
      accountActivity: {
        fetching: false,
        error: action.error,
      },
    }),
  },
  [FETCH_LOYALTY_ACCOUNT_PENDING_POINTS]: {
    request: () => ({
      accountPendingPoints: {
        fetching: true,
        error: undefined,
      },
    }),
    success: (_state, action) => ({
      accountPendingPoints: {
        data: action.data,
        fetching: false,
        error: undefined,
      },
    }),
    failure: (_state, action) => ({
      accountPendingPoints: {
        fetching: false,
        error: action.error,
      },
    }),
  },
  [FETCH_LOYALTY_ACCOUNT]: {
    request: () => ({
      account: {
        fetching: true,
        error: undefined,
      },
    }),
    success: (_state, action) => ({
      account: {
        data: action.data ? {
          ...action.data,
          fetchedAt: moment().utc().toISOString(),
        } : undefined,
        fetching: false,
        error: undefined,
      },
    }),
    failure: (_state, action) => ({
      account: {
        fetching: false,
        error: action.error,
      },
    }),
  },
  [FETCH_LOYALTY_ACCOUNT_ELIGIBILITY]: {
    request: () => ({
      eligibilityTier: {
        fetching: true,
        error: undefined,
      },
    }),
    success: (_state, action) => ({
      eligibilityTier: {
        data: action.data,
        fetching: false,
        error: undefined,
      },
    }),
    failure: (_state, action) => ({
      eligibilityTier: {
        fetching: false,
        error: action.error,
      },
    }),
  },
  [FETCH_LOYALTY_POINTS_EARN_CALCULATION]: {
    request: (state, action) => ({
      pointsEarnCalculations: {
        ...state.pointsEarnCalculations,
        [action.pointsEarnCalculationKey]: { fetching: true },
      },
    }),
    success: (state, action) => ({
      pointsEarnCalculations: {
        ...state.pointsEarnCalculations,
        [action.pointsEarnCalculationKey]: { data: action.data, fetching: false },
      },
    }),
    failure: (state, action) => ({
      pointsEarnCalculations: {
        ...state.pointsEarnCalculations,
        [action.pointsEarnCalculationKey]: { error: action.error, fetching: false },
      },
    }),
  },
  [SUBMIT_LOYALTY_POINTS_BURN_CALCULATION]: {
    request: (state, action) => {
      return {
        pointsBurnCalculations: {
          ...state.pointsBurnCalculations,
          [action.pointsBurnCalculationKey]: { fetching: true },
        },
      }
    },
    success: (state, action) => {
      return {
        pointsBurnCalculations: {
          ...state.pointsBurnCalculations,
          [action.pointsBurnCalculationKey]: { data: action.data, fetching: false },
        },
      }
    },
    failure: (state, action) => {
      return {
        pointsBurnCalculations: {
          ...state.pointsBurnCalculations,
          [action.pointsBurnCalculationKey]: { error: action.error, fetching: false },
        },
      }
    },
  },
  [FETCH_LOYALTY_CONFIG]: {
    request: () => {
      return {
        fetchingConfig: true,
      }
    },
    success: (state, action) => {
      return {
        config: action.data,
        fetchingConfig: false,
      }
    },
    failure: (state, action) => {
      return {
        configError: action.error,
        fetchingConfig: false,
      }
    },
  },
  [USER_LOGOUT]: {
    success: () => INITIAL_LOYALTY_STATE,
  },
  [FETCH_LATEST_LOYALTY_ACCOUNT_DETAILS]: {
    success: (state, action) => {
      return {
        account: {
          data: action.data ? {
            ...action.data,
            fetchedAt: moment().utc().toISOString(),
          } : undefined,
          fetching: false,
        },
      }
    },
  },
})

export default createAppReducer<App.LoyaltyState>(INITIAL_LOYALTY_STATE, {
  [API_CALL_REQUEST]: (state, action) => apiCalls(state, action),
  [API_CALL_FAILURE]: (state, action) => apiCalls(state, action),
  [API_CALL_SUCCESS]: (state, action) => apiCalls(state, action),
  [CLEAR_LOYALTY_ENROLMENT]: () => ({
    enrolment: undefined,
  }),
})
